import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { UseQueryResult } from '@tanstack/react-query'
import { isUndefined } from 'lodash'
import { EEBusMiddlewareDto } from '../types'
import { getEebusInfoFromEmc } from '../api'
import { usePortalQuery } from 'src/Libs/api'

/**
 * Request for Eebus information from emc data
 * @param installationId InstallationId number
 * @param emcId EMCId
 * @param enabled
 * @returns EEBusMiddlewareDto
 */
export const useFetchEebusInfoFromEmc = (
  installationId: number | undefined,
  emcId: string | null,
  enabled = true
): UseQueryResult<Nullable<EEBusMiddlewareDto>, Error> => {
  const authFetch = useAuthFetchWithResponse()

  return usePortalQuery({
    queryKey: ['installation', installationId, 'device-links', emcId, 'middlewares-eebus'],
    queryFn: () => getEebusInfoFromEmc(installationId!, emcId!, authFetch).then(res => res.value),
    enabled: !isUndefined(installationId) && !!emcId && enabled,
  })
}
